module.exports = __webpack_public_path__ + "img/zuanshi-01.20b69c16.png";